import { Component, computed, inject, input, signal } from '@angular/core';
import { ParseRequestsStore } from '../../stores/parse-requests.store';
import {
  Skeleton,
  Button,
  PopoverDirective,
  PopoverComponent,
  MenuList,
  MenuListItem,
} from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';
import { environment } from '../../../../../environments/environment';

import { DisableInDemoModeDirective } from '../../../demo/directives/disable-in-demo-mode';

@Component({
  selector: 'app-create-parse-request-button',
  imports: [
    Skeleton,
    Button,
    NgIcon,
    PopoverDirective,
    TranslocoPipe,
    PopoverComponent,
    RouterLink,
    DatePipe,
    MenuList,
    MenuListItem,
    DisableInDemoModeDirective,
  ],
  templateUrl: './create-parse-request-button.html',
})
export class CreateParseRequestButton {
  private parseRequestsStore = inject(ParseRequestsStore);
  protected activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  disabled = input<boolean>(false);

  organizationId = input.required<string>();
  mode = input<'filled' | 'outlined'>('filled');

  private isCreateLoading = this.parseRequestsStore.isCreateLoading;
  private isFakeDelayLoading = signal(false);
  protected isLoading = computed(() => this.isCreateLoading() || this.isFakeDelayLoading());

  protected parseRequestsLoading = this.parseRequestsStore.isLoading;
  protected openParseRequests = this.parseRequestsStore.openParseRequests;

  protected async onClickCreateParseRequest() {
    this.isFakeDelayLoading.set(true);
    await new Promise((resolve) => setTimeout(resolve, environment.delays.openParseRequestMs));
    const openParseRequests = this.openParseRequests();
    if (openParseRequests.length > 0) {
      await this.router.navigate(
        [
          '/organizations',
          this.organizationId(),
          'parse-requests',
          openParseRequests[0].id,
          'create',
        ],
        {
          relativeTo: this.activatedRoute,
        },
      );
      this.isFakeDelayLoading.set(false);
      return;
    }
    try {
      const id = await this.parseRequestsStore.create();
      if (id) {
        await this.router.navigate(
          ['/organizations', this.organizationId(), 'parse-requests', id, 'create'],
          {
            relativeTo: this.activatedRoute,
            queryParams: { showDialog: 'true' },
          },
        );
      }
      this.isFakeDelayLoading.set(false);
    } catch (e) {
      this.isFakeDelayLoading.set(false);
      throw e;
    }
  }
}
